import { BoardType } from "@sportactics/board-editing";
import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useBoardTypeLocalPersistence } from "./use-board-type-local-persistence";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBoardTypeLocalSWR() {
  const { getBoardType } = useBoardTypeLocalPersistence();

  const fetchBoardType = async (): Promise<BoardType | null> =>
    (await getBoardType()) ?? null;

  return useSWR(getBoardTypeLocalSWRKey(), fetchBoardType, { suspense: true });
}

export function getBoardTypeLocalSWRKey(): BoardTypeLocalSWRKey {
  return getSWRKey(SwrStore.LocalBoardType);
}

export type BoardTypeLocalSWRKey = readonly [SwrStore];
